<template>
  <div class="nav-bar-item edit-icon">
    <el-tooltip
      class="item"
      effect="dark"
      content="遇到问题，可点击反馈"
      placement="bottom"
    >
      <span class="svg-container" @click="recordProblem">
        问题反馈
      </span>
    </el-tooltip>
    <el-dialog title="问题反馈" :visible.sync="dialogVisible" append-to-body>
      <el-form ref="faqColl" :rules="rules" :model="formData">
        <el-form-item
          label="反馈类型"
          prop="feedbackType"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formData.feedbackType"
            clearable
            placeholder="请选择"
            style="width:100%"
          >
            <el-option :key="0" label="使用问题" :value="0"> </el-option>
            <el-option :key="1" label="优化建议" :value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="问题模块"
          prop="modelCodePath"
          :label-width="formLabelWidth"
        >
          <el-cascader
            v-model="formData.modelCodePath"
            :options="resourceList"
            :props="optionProps"
            clearable
            popper-class="qen-cascader-area"
            style="width:100%"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item
          label="问题描述"
          prop="description"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请留下您的宝贵意见"
            maxlength="200"
            show-word-limit
            v-model="formData.description"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="图片上传"
          prop="pictures"
          :label-width="formLabelWidth"
        >
          <UploadCommon
            fileTitle=""
            :isAlone="false"
            :limit="8"
            :fileList.sync="formData.pictures"
            :sizeType="4"
            acceptType=".jpeg,.jpg,.png,.bmp,.apng"
            commonUpload
            group="assert"
            code="assert_question_file"
          >
          </UploadCommon>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reSetData">重 置</el-button>
        <el-button type="primary" @click="submitData">确认提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { problemsFeedback } from '@/api/global'
import { getOS, browser_type } from '@/utils'

export default {
  name: 'Qen',
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: '120px',
      optionProps: {
        value: 'resourceKey',
        label: 'resourceName',
        children: 'subList',
      },
      formData: {
        feedbackType: '',
        modelCodePath: [],
        description: '',
        pictures: [],
      },
      rules: {
        feedbackType: [
          { required: true, message: '请选择反馈类型', trigger: 'change' },
        ],
        modelCodePath: [
          { required: true, message: '请选择问题模块', trigger: 'change' },
        ],
        description: [
          { required: true, message: '请填写问题描述', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    formData: {
      handler(val) {
        // 先格式化img的数组，再进行存储
        if (val.pictures && val.pictures.length > 0) {
          for (let i = 0; i < val.pictures.length; i++) {
            val.pictures[i].cancel = '' // cancel值都为function，不能直接存储，这里做一遍数据格式化，全部置为 ''
          }
        }
        const pictures = val.pictures ? this.getUoloadCommonFileData(val.pictures) : JSON.stringify([])
        this.dataBase.save(this.userAccount, {
          formData: { ...val, pictures },
          ts: new Date().getTime(),
        })
      },
      deep: true,
    },
    dialogVisible(val) {
      // 弹窗开启，从前端存储中取数据
      val &&
        this.dataBase.get(this.userAccount).then((res) => {
          if (res.code === 200) {
            if (res.data.ts + 1000 * 60 * 60 * 24 * 7 >= new Date().getTime()) {
              const { formData } = res.data
              this.formData.feedbackType = formData.feedbackType
              this.formData.modelCodePath = formData.modelCodePath || []
              this.formData.description = formData.description
              this.formData.pictures = this.getURL({
                data: formData.pictures,
                defaultImg: [],
                needName: true,
              })
            } else {
              // 数据已过期（大于7天），删除缓存
              this.dataBase.delete(this.userAccount)
            }
          } else {
            // 未从缓存中获取到数据，重置表单
            this.$refs.faqColl.resetFields()
            this.formData.pictures = []
          }
        })
    },
  },
  computed: {
    ...mapGetters(['resourceList', 'userInfo']),
    userAccount() {
      return this.userInfo.userAccount || 'faqColl'
    },
  },
  mounted() {},
  methods: {
    // 获取级联的中文-resourceName
    getModelName(keyList) {
      const nameList = keyList.reduce((total, item) => {
        total = total.concat(getName(item, this.resourceList))
        return total
      }, [])
      function getName(key, tree) {
        const nq = []
        for (let i = 0; i < tree.length; i++) {
          if (tree[i].resourceKey === key) {
            nq.push(tree[i].resourceName)
            return nq
          }
          if (tree[i].subList && tree[i].subList.length > 0) {
            const sq = getName(key, tree[i].subList)
            if (sq && sq.length > 0) {
              return nq.concat(sq)
            }
          }
        }
      }
      return nameList
    },

    // 点击弹窗显示
    recordProblem() {
      this.dialogVisible = true
    },
    // 重置表单
    reSetData() {
      this.$refs.faqColl.resetFields()
      this.dataBase.delete(this.userAccount)
    },
    // 提交数据
    async submitData() {
      const parmas = {
        ...this.formData,
        pictures: this.getUoloadCommonFileData(this.formData.pictures),
      }
      parmas.modelNamePath = this.getModelName(parmas.modelCodePath).join('-') // 中文之间用 '-' 连接
      if (typeof parmas.modelCodePath === 'object') {
        parmas.modelCodePath = parmas.modelCodePath.join('-') // resourceCode 之间也用 '-' 连接
      }
      parmas.userRole = this.$store.state.user.userInfo.roleList[0].name // 用户角色中文名
      parmas.sessionSource =
        this.$store.getters.userInfo.sessionCompanyId === 0 ? '集团' : '公司' // 反馈问题的来源，（是公司还是集团）
      const extendDesc = {
        // 一些系统信息
        system: getOS(), // 操作系统
        explorer: browser_type(), // 浏览器类型
        screenSize: `${window.screen.availWidth}*${window.screen.availHeight}`, // 屏幕尺寸
        url: window.location.href, // 反馈问题的当前url
      }
      parmas.extendDesc = extendDesc
      this.$refs.faqColl.validate(async (valid) => {
        if (!valid) return
        const res = await problemsFeedback(parmas)
        if (res.code === 1) {
          // 反馈成功后做删除存储数据
          this.dataBase.delete(this.userAccount)
          this.$message.success('已收到您的反馈，我们将及时处理')
          this.dialogVisible = false
        }
      })
    },
  },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.edit-icon {
  margin-left: 5px;
  margin-right: 0px;
}
.dialog-footer {
  text-align: center;
}
.svg-container {
  display: block;
  width: 95px;
  text-align: right;
  padding-right: 12px;
  // vertical-align: middle;
  background-image: url(../assets/img/feedback.png);
  background-repeat: no-repeat;
  background-position: 6px 2px;
  &:hover {
    background-image: url(../assets/img/feedback_h.png);
  }
}
</style>
<style lang="scss">
.qen-cascader-area {
  .el-cascader-panel {
    .el-cascader-menu:nth-child(1) {
      min-width: 120px !important;
    }
    .el-cascader-menu:nth-child(2) {
      min-width: 125px !important;
    }
    .el-cascader-menu:nth-child(3) {
      min-width: 175px !important;
    }
    .el-cascader-menu:nth-child(4) {
      min-width: 200px !important;
    }
    .el-cascader-menu:nth-child(5) {
      min-width: 160px !important;
    }
  }
}
</style>
